"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fluxActions = require("flux-actions");

var _immutable = require("immutable");

var _actions = require("./actions");

var _handleActions;

var initialState = new _immutable.Map({
  storeStatus: new _immutable.Map(),
  syncSettings: new _immutable.Map({
    enabled: false
  })
});

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _actions.FetchStoresStatusesActionTypes.SUCCESS, function (state, action) {
  return state.set('storeStatus', (0, _immutable.Map)(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.FetchSyncSettingsActionTypes.SUCCESS, function (state, action) {
  return state.set('syncSettings', (0, _immutable.Map)(action.payload.data));
}), (0, _defineProperty2.default)(_handleActions, _actions.UpdateSyncSettingsActionTypes.SUCCESS, function (state, action) {
  return state.setIn(['syncSettings', 'enabled'], action.payload.props.enabled);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;